export function formatStringWithLinebreaks(text: string): string[] {
  if (!text) {
    return []
  }

  const findLinebreaks = /<br?.\/>|<br\s>|<br>/gim

  return text.split(findLinebreaks).map((t) => t.trim())
}
